module.exports = __webpack_public_path__ + "static/media/procore_logo.464a8570.svg";